export const SUBSCRIPTION_QUOTE_TYPES = ['membership', 'pass', 'lesson'];
export const MAX_PASSES_PER_ORDER = 10;
//# sourceMappingURL=quote.js.map